const URL = '/cuentas';

const state = {
  all: [],
  selected: {
    id: null,
    documento: null,
    razon_social: null,
    numero: null,
    descripcion: null,
    tolerancia: null,
    cierre: null,
    saldo_usuario: 0,
    saldo_pleno: 0,
    saldo_subsidio: 0,
    kilos_pleno: 0,
    credito_demas: 0,
    cliente_id: null,
    recalculado_at: null,
    created_at: null,
    updated_at: null
  },
  filters: {
    searchText: null,
    numero: null,
    descripcion: null,
    cierre_from: null,
    cierre_to: null,
    cliente_id: null,
    cuenta_id: null,
    // cliente
    documento: null,
    razon_social: null,
    inactivo: null
  },
  loading: false,
  options: {
    itemsPerPage: 50,
    page: 1,
    sortBy: [],
    sortDesc: []
  },
  itemsLength: null,
}

// GETTERS
const getters = {
  all (state) {
    return state.all
  },
  selected (state) {
    return state.selected
  },
  filters (state) {
    return state.filters
  },
  itemsLength (state) {
    return state.itemsLength
  },
  options (state) {
    return state.options
  },
  loading (state) {
    return state.loading
  },
}

// ACTIONS
const actions = {
  onClearAll ({ commit }) {
    commit('setAll', [])
    commit('setOptions', {
      itemsPerPage: 50,
      page: 1,
      sortBy: [],
      sortDesc: []
    })
  },
  onClearFilters({ commit }) {
    commit('setFilters', {
      searchText: null,
      numero: null,
      descripcion: null,
      cierre_from: null,
      cierre_to: null,
      cliente_id: null,
      cuenta_id: null,
      // cliente
      documento: null,
      razon_social: null,
      inactivo: null
    })
  },
  onClearSelected ({ commit}) {
    commit('setSelected', {
      id: null,
      documento: null,
      razon_social: null,
      numero: null,
      descripcion: null,
      cierre: null,
      saldo_usuario: 0,
      saldo_pleno: 0,
      saldo_subsidio: 0,
      kilos_pleno: 0,
      credito_demas: 0,
      tolerancia: null,
      cliente_id: null,
      recalculado_at: null,
      created_at: null,
      updated_at: null,
    })
  },
  onFetch ({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.get(URL, {
        params: {
          itemsPerPage: state.options.itemsPerPage,
          page: state.options.page,
          sortBy: state.options.sortBy[0],
          sortDesc: state.options.sortDesc[0] ? 1 : 0,
          searchText: state.filters.searchText,
          numero: state.filters.numero,
          documento: state.filters.documento,
          razon_social: state.filters.razon_social,
          inactivo: state.filters.inactivo,
          cliente_id: state.filters.cliente_id,
        }
      })
        .then(response => {
          commit('setAll', response.data.data)
          commit('setItemsLength', response.data.meta.total)
          if (state.options.page + state.options.itemsPerPage > response.data.meta.total)
            commit('setPage', 1)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
}

// MUTATIONS
const mutations = {
  setAll (state, payload) {
    state.all = payload.slice()
  },
  setSelected (state, payload) {
    state.selected = Object.assign({}, payload)
  },
  setFilters (state, payload) {
    state.filters = Object.assign({}, payload)
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setPage (state, payload) {
    state.options.page = payload
  },
  setItemsPerPage (state, payload) {
    state.options.itemsPerPage = payload
  },
  setItemsLength (state, payload) {
    state.itemsLength = payload
  },
  setOptions (state, payload) {
    state.options = payload
  },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
